import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { reactKeyFromIDSK } from "@examspark/common";
import { IDSK, Resource } from "@examspark/types";

import { gqlQuery } from "../../api/util";

import ResourceViewerPassage from "./ResourceViewerPassage";

const StyledResource = styled.div`
  line-height: 1.7em;

  .resource-actions {
    margin: 1em;
  }

  audio {
    display: block;
    max-width: 75%;
    width: 75%;
    margin: 0 auto;
  }

  img {
    margin: 0 auto;
    display: block;
    max-width: 100%;
  }

  video {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }

  .passage {
    margin: 0 auto;
  }
`;

const ResourceViewer = (props: { resource?: Resource; resourceKey?: IDSK }) => {
  const [resource, setResource] = useState<Resource>();

  useEffect(() => {
    if (props.resource) {
      setResource(props.resource);
      return;
    }

    gqlQuery({
      query: getContextPreview,
      variables: {
        id: props.resourceKey?.id,
        sk: props.resourceKey?.sk,
      },
    }).then((rsp) => {
      setResource(rsp.data?.getResource);
    });
  }, [props.resourceKey, props.resource]);

  if (!resource) return null;

  let rsc;
  if (resource && resource.type) {
    // This was lifted from `cms` only providing support for passages at the
    // moment.
    switch (resource.type) {
      case "PASSAGE":
        rsc = <ResourceViewerPassage data={resource} />;
        break;
      // case RESOURCE_TYPE.AUDIO:
      //   rsc = <Audio data={resource} />;
      //   break;
      // case RESOURCE_TYPE.VIDEO:
      //   rsc = <Video data={resource} />;
      //   break;
      // case RESOURCE_TYPE.IMAGE:
      //   rsc = <Image data={resource} />;
      //   break;
      // case RESOURCE_TYPE.RUBRIC:
      //   rsc = <Rubric data={resource} />;
      //   break;
      // case RESOURCE_TYPE.DOCUMENT:
      //   rsc = <Document data={resource} />;
      //   break;
      // case RESOURCE_TYPE.WEB_LINK:
      // case "EXTERNAL_LINK":
      //   rsc = <ExternalLink data={resource} />;
      //   break;
      // default:
      //   rsc = <></>;
      //   break;
    }
  }

  return (
    <StyledResource key={reactKeyFromIDSK(resource)}>{rsc}</StyledResource>
  );
};

export default ResourceViewer;

export const getContextPreview = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      idInc
      sk
      type
      version
      resourceId
      bankId
      workspaceId
      name
      description
      content {
        body
        rubric
      }
      data
      file {
        name
        region
        bucket
        key
        size
        mimetype
        format
        extension
      }
      author
      maturity
      subject
      language
      grade
      dok
      blooms
      excerpt
      lexile
      rmm
      flesch
      wordCount
      parccTextComplexity
      schemaVersion
      createdAt
      updatedAt
      stats
      statsAt
      ownerUserIds
    }
  }
`;
